import React from "react"
import { graphql, PageProps } from "gatsby"

import Layout from "../components/layout"
import { Form, Description } from "../components/contact"
import { ContactQuery } from "./__generated__/ContactQuery"
import { Button, TextInput } from "../components/ui";
import { Loader, Send } from "react-feather";

export default ({data, location}: PageProps<ContactQuery>) => {

    const api_url = data.site.siteMetadata.contact.api_url;
    const hasContactForm = (api_url);
    // @ts-ignore
    return (
        <Layout
            seo={{
                title: "Contact",
            }}
            location={location}
        >
            <div className="container mx-auto py-12">
                <div className="title py-12 text-center">
                    <h2 className="font-black text-5xl text-color-1">
                        お問い合わせ
                    </h2>
                </div>
                <div className="flex flex-wrap pb-40">
                    {hasContactForm &&
                        <div className="w-full lg:w-1/2 px-6">
                        {/*<Form api={api_url}/>*/}

                            <form action="https://hyperform.jp/api/Tra0Oeyh" method="POST" target="_blank">
                                <TextInput
                                  label="氏名"
                                  name="name"
                                  type="text"
                                />
                                <TextInput
                                  label="会社名（任意）"
                                  name="company"
                                  type="text"
                                />
                                <TextInput
                                  label="Email"
                                  type="text"
                                  name="email"
                                />
                                <TextInput
                                  label="お問い合わせ内容"
                                  type="text"
                                  name="message"
                                />

                                <Button
                                  type="button,submit"
                                  title="送信"
                                  iconRight={<IconRight spin={false}/>}
                                />
                            </form>
                    </div>
                    }
                    <div className={`w-full ${hasContactForm ? 'lg:w-1/2' : 'lg:w-2/3 mx-auto'} px-6 pt-8`}>
                        <Description data={data.site.siteMetadata.contact} />
                    </div>
                </div>
            </div>
        </Layout>
    )
}
const IconRight = ({ spin = false }) => {
    if(spin) {
        return (
          <span className="spin" style={{
              display: "inline-block",
              verticalAlign: "middle",
              animationDuration: "5s"
          }}>
                <Loader />
            </span>
        )
    }
    return <Send />
}

export const query = graphql`
    query ContactQuery {
        site {
            siteMetadata {
                contact {
                    api_url
                    description
                    mail
                    phone
                    address
                }
            }
        }
    }
`
